<template>
  <div>
    <div class="row row-equal">
      <div class="flex md12">
        <va-card title="Impayés"> - </va-card>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

import { sortedUniq, sortBy } from "lodash";
import moment from "moment";

export default {
  name: "publications-list",
  props: ["idnumero", "edition"],
  data() {
    return {
      showCreatePublication: false,
      showEditPublication: false,
      showPublication: false,
      tabIndex: 0,
      publicationsList: [],
      activeYear: null,
      //export within context
      moment: moment,
    };
  },
  created() {
    this.updateList();
  },
  watch: {
    idnumero: {
      immediate: true,
      handler(newvalue) {
        if (this.edition === "edit" && newvalue) {
          this.showEditPublication = true;
          this.showPublication = false;
          this.showCreatePublication = false;
        } else if (newvalue) {
          this.showEditPublication = false;
          this.showPublication = true;
          this.showCreatePublication = false;
        } else {
          this.showEditPublication = false;
          this.showPublication = false;
          this.showCreatePublication = false;
        }
      },
    },
    edition: {
      immediate: true,
      handler(newvalue) {
        if (this.edition === "edit" && this.idnumero) {
          this.showEditPublication = true;
          this.showPublication = false;
          this.showCreatePublication = false;
        }
      },
    },
  },
  computed: {
    activeNumbers() {
      let tmpList = this.publicationsList.filter((element) => {
        if (
          element.date_previsionnelle.substring(0, 4) === this.activeYear &&
          !element.hors_serie
        )
          return true;

        return false;
      });

      return tmpList;
    },
    activeHS() {
      let tmpList = this.publicationsList.filter((element) => {
        if (
          element.date_previsionnelle.substring(0, 4) === this.activeYear &&
          element.hors_serie
        )
          return true;

        return false;
      });

      return tmpList;
    },
    yearList() {
      let tmpList = [];
      this.publicationsList.forEach((element) => {
        tmpList.push(element.date_previsionnelle.substring(0, 4));
      });

      tmpList = sortedUniq(sortBy(tmpList));

      if (!this.activeYear) {
        this.activeYear = tmpList[0];
      }

      return tmpList;
    },
  },
  methods: {
    closeViewer() {
      this.$router.push({
        name: "liste-publication",
      });
    },
    openNumero(element) {
      this.$router.push({
        name: "liste-publication",
        params: { idnumero: element.idpublication },
      });
      this.showPublication = true;
    },
    backgroundColor(element) {
      if (element.isactif) {
        return { backgroundColor: "#4ae387" };
      } else if (element.date_cloture) {
        return { backgroundColor: "#ccc" };
      } else {
        return { backgroundColor: "#4ab2e3" };
      }
    },
    async updateList() {
      try {
        let temp = await axios.get("/api/publications/list");
        this.publicationsList = temp.data;
      } catch (error) {
        console.log(error);
        this.launchEpicmaxToast(
          "Erreur lors de la récupération de la liste des publications"
        );
      }
    },
    createNew() {
      if (this.idnumero) {
        return;
      }
      this.showCreatePublication = true;
    },
    launchEpicmaxToast(toast) {
      this.showToast(toast, {
        position: "bottom-center",
        duration: 5000,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.fullwidth {
  width: 95%;
}

.container {
  text-align: center;
  min-height: 6em;
}

.container:hover {
  cursor: pointer;
}

.numero-box {
  color: white;
  font-size: 1.5em;
  font-weight: bold;
}

.hors-series-text {
  color: white;
  font-size: 1em;
  font-weight: bold;
}

.date-box {
  color: white;
}
</style>
